import React, { Fragment } from "react";
import { MiniModalBox, TitleModal } from "./styled/MiniDialog.styled";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import { IoClose } from "react-icons/io5";
import StyledButton from "./elements/StyledButton";
import { BackDrop } from "../components/elements/Loader";

const StyledMiniModalTitle = (props) => {
  const { children, onClose, ...other } = props;
  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <IoClose />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

export default function MiniModal({
  setOpenModal,
  children,
  confirmationLabel,
  title,
  isFeedback,
  feedback,
  loading,
  ...props
}) {
  const handleCloseAll = () => {
    setOpenModal(false);
  };
  const handleClose = () => {
    if (isFeedback) {
      feedback();
      return;
    }
    setOpenModal(false);
  };

  return (
    <Fragment>
      {loading ? (
        <BackDrop />
      ) : (
        <MiniModalBox {...props} maxWidth={false}>
          <StyledMiniModalTitle onClose={handleCloseAll}>
            <TitleModal>{title}</TitleModal>
          </StyledMiniModalTitle>
          <DialogContent dividers>{children}</DialogContent>
          <DialogActions>
            {confirmationLabel && (
              <StyledButton
                variant={"contained"}
                size={"small"}
                onClick={handleClose}
              >
                {confirmationLabel}
              </StyledButton>
            )}
          </DialogActions>
        </MiniModalBox>
      )}
    </Fragment>
  );
}
